import { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { updateAd } from '../../../../modules/actions/ads'
import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'
import { TIKTOK_PLATFORM } from '../../../../constants/selectLists/platformList'
import { VIDEO } from '../fields'
import { VIEWABILITY_POSTBID_PARTNER } from '../AdTikTokCreate/AdTikTokCreateForm/fields'

export default function useUpdateTikTokAdHandler(originalAdData, title) {
  const dispatch = useDispatch()

  const handleSubmit = useCallback(
    updatedValues => {
      const updateAdData = {
        // TikTok endpoint accepts only the PUT method, so we need to send all original data
        ...originalAdData,
        // during update only the id of the video is sent, not the full video details object
        [VIDEO]: originalAdData[VIDEO].id,
        ...updatedValues,
        meta: { [HISTORY_META_EDIT_SECTION]: title }
      }

      if (updateAdData[VIEWABILITY_POSTBID_PARTNER] === 'UNSET') {
        // if viewability postbid partner is unset, we need to remove it from the update data
        delete updateAdData[VIEWABILITY_POSTBID_PARTNER]
      }

      dispatch(updateAd(updateAdData, originalAdData.id, TIKTOK_PLATFORM, { requestMethod: 'PUT' }))
    },
    [dispatch, originalAdData, title]
  )

  return useMemo(() => handleSubmit, [handleSubmit])
}
